import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { signInWithEmailAndPassword, signInWithPopup } from 'firebase/auth';
import { auth, googleProvider } from '../lib/firebase.js';
import SocHeader from '../components/SocHeader.jsx';
import Footer from '../components/Footer.jsx';

export default function SignIn() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const returnTo = params.get('returnTo');
  const from = returnTo || location.state?.from?.pathname || '/profile';

  const goNext = () => {
    if (returnTo && returnTo.startsWith('/')) {
      // Legacy static page — full page navigation
      window.location.replace(returnTo);
    } else {
      navigate(from, { replace: true });
    }
  };

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email.trim(), password);
      goNext();
    } catch (error) {
      setErr(error.message.replace('Firebase: ', ''));
    } finally {
      setLoading(false);
    }
  };

  const onGoogle = async () => {
    setErr('');
    setLoading(true);
    try {
      await signInWithPopup(auth, googleProvider);
      goNext();
    } catch (error) {
      setErr(error.message.replace('Firebase: ', ''));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SocHeader />
      <section className="auth-section" id="main">
        <div className="auth-card">
          <div className="hero-eyebrow">AUTHENTICATE</div>
          <h2 className="auth-headline">Sign In</h2>
          <p className="auth-sub">Resume your training. Sync progress across devices.</p>

          {err && <div className="form-msg error">AUTH FAIL — {err}</div>}

          <button type="button" className="btn btn-ghost btn-block" onClick={onGoogle} disabled={loading}>
            Continue with Google
          </button>

          <div className="auth-divider"><span>OR</span></div>

          <form onSubmit={onSubmit} className="contact-form">
            <div className="form-group">
              <label className="form-label" htmlFor="email">Email</label>
              <input id="email" type="email" className="form-input" autoComplete="email" required
                value={email} onChange={(e) => setEmail(e.target.value)} placeholder="OPERATOR@DOMAIN" />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="password">Password</label>
              <input id="password" type="password" className="form-input" autoComplete="current-password" required
                value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </div>
            <button type="submit" className="btn btn-block" disabled={loading}>
              {loading ? 'AUTHENTICATING…' : 'Sign In →'}
            </button>
          </form>

          <div className="auth-links">
            <Link to="/forgot">Forgot password?</Link>
            <span>·</span>
            <Link to="/signup">Create account</Link>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
